import React from 'react';
import { Link } from 'react-router-dom';
import { getbussinesscategory, getsearchBusinesses } from "../../api/ClientApi";

export default class HeroOne extends React.Component {
    state = {
        categories: [
         
        ],
        searchData: {
            bussiness:'',
            country:'',
            category:'',
            state: ''
        },
        isSearching: false
    };
    

    componentDidMount() {


        const secret_key = process.env.REACT_APP_SECRET_KEY;
        const $ = window.$;

        // 🔹 LOAD CATEGORIES
        getbussinesscategory(secret_key)
            .then((response) => {
                console.log("Category API Response:", response);

                const categories = Array.isArray(response.data)
                    ? response.data
                    : response;
                   

                this.setState({ categories }, () => {
                    // Update niceSelect AFTER categories are loaded
                    if ($ && $('select').length) {
                        setTimeout(() => $('select').niceSelect('update'), 0);
                    }
                });
            })
            .catch(err => console.error("Category Error:", err));

     
    }

    handleInputChange = (e) => {
        const { name, value } = e.target;
        console.log(name,value)

        this.setState(prevState => ({
            searchData: {
                ...prevState.searchData,
                [name]: value
            }
        }));
    };

    handlePlacesSearch = async (e) => {
        e.preventDefault();

        const { bussiness, country,state, category } = this.state.searchData;
        const secret_key = process.env.REACT_APP_SECRET_KEY;
        this.setState({ isSearching: true });

        try {
            const businesses = await getsearchBusinesses(
                secret_key,
                bussiness,
                state,
                country,
                category,
            );

            if (this.props.onSearchResults) {
                this.props.onSearchResults(businesses);
            }

        } catch (err) {
            console.error(err);
        } finally {
            this.setState({ isSearching: false });
        }
    };


    render() {
        const { categories, searchData, isSearching } = this.state;
        return (
            <>
                 <style>{`
                    /* Remove border & outline from native select */
                    .selectmenu {
                        border: none !important;
                        outline: none !important;
                        box-shadow: none !important;
                        background: transparent;
                        margin-left:12%;
                        margin-top:5%;
                        color:#6c757d !important;
                    }

                    /* Remove border & outline from niceSelect */
                    .select-box .nice-select {
                        border: none !important;
                        outline: none !important;
                        box-shadow: none !important;
                        background: transparent;
                        padding-left: 0;
                        height: auto;
                        line-height: normal;
                    }

                    /* Remove focus styles */
                    .select-box .nice-select:focus,
                    .select-box .nice-select.open {
                        border: none !important;
                        box-shadow: none !important;
                    }

                    /* Match input text style */
                    .select-box .nice-select span.current {
                        color: #6c757d; /* same as inputs */
                        font-size: 14px;
                    }
                   
                `}</style>
                {/* Start Banner One */}
                <section className="banner-one">
                    <div className="banner-one__inner">
                        <div
                        className="slider-bg-slide"
                        style={{
                            backgroundImage: "url('/assets/images/resources/headerpic.png')",
                            backgroundSize: 'cover',
                            backgroundPosition: 'center',
                            backgroundRepeat: 'no-repeat'
                        }}
                        >
                        </div>

                        <div className="slider-bg-slide-overly" ></div>
                        <div className="container">
                            <div className="banner-one__content text-center">
                                <div className="title" >
                                    <h2>Discover Top-Rated Businesses</h2>
                                </div>
                                <div className="text">
                                   <p>Explore the best places, services, and companies around you with ease.</p>
                                </div>


                                {/* Start Banner One Tab Box */}
                                <div className="banner-one__tab-box">
                                    <div className="row">
                                        <div className="col-xl-12">
                                            <div className="banner-one__tab tabs-box">
                                                <div className="banner-one__tab-button">
                                                    <ul className="tab-buttons clearfix">
                                                        <li data-tab="#places" className="d-none tab-btn active-btn">
                                                            <h4>Places</h4>
                                                        </li> 
                                                    </ul>
                                                </div>

                                                <div className="tabs-content">

                                                    {/* Start Tab */}
                                                    <div className="tab active-tab" id="places">
                                                        <div className="banner-one__tab-content-item">
                                                            <div className="banner-one__tab-content-places">
                                                                <div className="row">
                                                                    <div className="col-xl-12">
                                                                        <div className="banner-one__tab-content-places-form">
                                                                            <form onSubmit={this.handlePlacesSearch} className="comment-one__form contact-form-validated" novalidate="novalidate">
                                                                                <ul>
                                                                                    <li>
                                                                                        <div className="comment-form__input-box">
                                                                                            <div className="icon">
                                                                                                <span className="fas fa-keyboard"></span>
                                                                                            </div>
                                                                                            <input
																								type="text"
																								name="bussiness"
																								value={searchData.bussiness}
																								onChange={this.handleInputChange}
																								placeholder="Bussiness Name"
																							/>
                                                                                        </div>
                                                                                    </li>

                                                                                    <li>
                                                                                        <div className="comment-form__input-box">
                                                                                            <div className="icon">
                                                                                                <span className="icon-pin"></span>
                                                                                            </div>
                                                                                            <input
																								type="text"
																								name="state"
																								value={searchData.state}
																								onChange={this.handleInputChange}
																								placeholder="State"
																							/>
                                                                                        </div>
                                                                                    </li>
                                                                                     <li>
                                                                                        <div className="comment-form__input-box">
                                                                                            <div className="icon">
                                                                                                <span className="icon-pin"></span>
                                                                                            </div>
                                                                                            <input
																								type="text"
																								name="country"
																								value={searchData.country}
																								onChange={this.handleInputChange}
																								placeholder="Country"
																							/>
                                                                                        </div>
                                                                                    </li>


                                                                                      <li >
                                                                                        <div
                                                                                            className="comment-form__input-box clearfix selectlibox">
                                                                                            <div className="icon">
                                                                                                <span className="icon-list me-2"></span>
                                                                                            </div>
                                                                                            <div className="select-box" >
                                                                                                <select
																									name="category"
																									className="selectmenu wide form-select"
																									value={searchData.category}
																									onChange={this.handleInputChange}
                                                                                                   id="category"
																								>
																									<option value="">All Categories</option>
																									{categories.map(cat => (
																										<option value={cat.id}>
																											{cat.title}
																										</option>
																									))}
																								</select>
                                                                                            </div>
                                                                                        </div>
                                                                                    </li>
                                                                                    
                                                                                    <li className='float-end' >
                                                                                        <button className="thm-btn comment-form__btn" type="submit" data-loading-text="Please wait...">Search
                                                                                            <span className="icon-search"></span>
                                                                                        </button>
                                                                                    </li>
                                                                                </ul>
                                                                            </form>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {/* End Tab */}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* End Banner One Tab Box Tab Box */}


                                <div className="banner-one__categories d-none">
                                    <div className="title">
                                        <h4>Just looking around ? Use quick search by category :</h4>
                                    </div>
                                    <ul className="banner-one__categories-list">

                                        <li className="banner-one__categories-list-item">
                                            <div className="inner">
                                                <div className="icon">
                                                    <span className="icon-hotels"></span>
                                                </div>
                                                <p><Link to={process.env.PUBLIC_URL + `/`}>Hotels</Link></p>
                                            </div>
                                        </li>

                                        <li className="banner-one__categories-list-item">
                                            <div className="inner">
                                                <div className="icon">
                                                    <span className="icon-drink"></span>
                                                </div>
                                                <p><Link to={process.env.PUBLIC_URL + `/`}>Events</Link></p>
                                            </div>
                                        </li>

                                        <li className="banner-one__categories-list-item">
                                            <div className="inner">
                                                <div className="icon">
                                                    <span className="icon-shopping-cart"></span>
                                                </div>
                                                <p><Link to={process.env.PUBLIC_URL + `/`}>Shops</Link></p>
                                            </div>
                                        </li>

                                        <li className="banner-one__categories-list-item">
                                            <div className="inner">
                                                <div className="icon">
                                                    <span className="icon-big-cheeseburger"></span>
                                                </div>
                                                <p><Link to={process.env.PUBLIC_URL + `/`}>Restaurants</Link></p>
                                            </div>
                                        </li>


                                        <li className="banner-one__categories-list-item">
                                            <div className="inner">
                                                <div className="icon">
                                                    <span className="icon-dumbbell"></span>
                                                </div>
                                                <p><Link to={process.env.PUBLIC_URL + `/`}>Fitness</Link></p>
                                            </div>
                                        </li>

                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                {/* End Banner One */}
            </>
        )
    }
}
